import React from 'react';
export function BonusesSection() {
  return <section className="py-20 bg-[#111] relative border-t border-white/5" data-id="element-1">
      <div className="max-w-6xl mx-auto px-5 md:px-8" data-id="element-2">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-6" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-poppins font-bold text-white leading-tight" data-id="element-4">
            Pero este camino no termina solo en la lectura.
          </h2>
          <p className="text-xl text-gray-300 font-light" data-id="element-5">
            Porque comprender es importante. Pero experimentar lo comprendido…{' '}
            <span className="text-amber-500 font-medium" data-id="element-6">
              es lo que realmente empieza a transformar tu mirada.
            </span>
          </p>
          <p className="text-gray-400" data-id="element-7">
            Por eso, además de recibir el Libro de la Sabiduría, también
            accederás a{' '}
            <span className="text-white font-bold" data-id="element-8">
              3 bonos gratuitos especiales
            </span>
            , creados para ayudarte a profundizar, aplicar y vivir esta
            experiencia de transformación interior de una forma más práctica,
            íntima y personal.
          </p>
        </div>

        <div className="mb-16 relative" data-id="element-9">
          <div className="absolute inset-0 bg-amber-500/10 blur-[100px] rounded-full" data-id="element-10"></div>
          <img src="https://cdn.magicpatterns.com/uploads/wwfgeaSJXEvBkz2o7gaRUe/magnific_crea-una-imagen-publicita_MXGqSrCDCm.png" alt="3 Bonos Exclusivos" className="w-full max-w-4xl mx-auto h-auto rounded-2xl shadow-2xl relative z-10 border border-white/10" data-id="element-11" />
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-12">
          {/* Bono 1 */}
          <div className="bg-black/50 border border-white/10 rounded-2xl p-8 hover:border-amber-500/50 transition-colors group" data-id="element-13">
            <div className="text-amber-500 font-poppins font-bold text-sm tracking-widest uppercase mb-2" data-id="element-14">
              Bono 1
            </div>
            <h3 className="text-xl font-poppins font-bold text-white mb-4 group-hover:text-amber-400 transition-colors" data-id="element-15">
              Activación Interior: 7 prácticas para despertar tu conciencia
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4" data-id="element-16">
              Este bono fue creado para ayudarte a llevar la sabiduría del ebook
              principal a tu vida diaria. No se trata solo de leer conceptos
              espirituales. Se trata de comenzar a experimentarlos desde tu
              interior.
            </p>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-17">
              Dentro encontrarás prácticas sencillas y profundas para conectar
              con tu respiración, aquietar tu mente, observar tus pensamientos y
              despertar una mayor claridad interna.
            </p>
          </div>

          {/* Bono 2 */}
          <div className="bg-black/50 border border-white/10 rounded-2xl p-8 hover:border-amber-500/50 transition-colors group" data-id="element-18">
            <div className="text-amber-500 font-poppins font-bold text-sm tracking-widest uppercase mb-2" data-id="element-19">
              Bono 2
            </div>
            <h3 className="text-xl font-poppins font-bold text-white mb-4 group-hover:text-amber-400 transition-colors" data-id="element-20">
              Diario de Sabiduría Interior: 21 preguntas para conocerte
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4" data-id="element-21">
              Porque la verdadera transformación comienza cuando te atreves a
              mirarte con honestidad. Este diario de introspección fue diseñado
              para ayudarte a descubrir pensamientos, emociones, creencias y
              patrones ocultos.
            </p>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-22">
              A través de 21 preguntas profundas, serás guiado a reflexionar
              sobre tu propósito, tu energía, tus miedos, tu intuición y la
              forma en que estás construyendo tu realidad.
            </p>
          </div>

          {/* Bono 3 */}
          <div className="bg-black/50 border border-white/10 rounded-2xl p-8 hover:border-amber-500/50 transition-colors group" data-id="element-23">
            <div className="text-amber-500 font-poppins font-bold text-sm tracking-widest uppercase mb-2" data-id="element-24">
              Bono 3
            </div>
            <h3 className="text-xl font-poppins font-bold text-white mb-4 group-hover:text-amber-400 transition-colors" data-id="element-25">
              Mapa Energético de los Chakras: Guía visual
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4" data-id="element-26">
              Este bono te ayudará a comprender de forma clara, visual y
              sencilla el significado simbólico de los 7 chakras principales.
            </p>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-27">
              Explorarás el significado de la raíz, el sacro, el plexo solar, el
              corazón, la garganta, el tercer ojo y la corona. Conocerás sus
              emociones relacionadas, señales de equilibrio y señales de bloqueo
              simbólico.
            </p>
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-28">
          <a href="#comprar" className="inline-flex items-center justify-center bg-gradient-to-r from-amber-500 to-amber-700 hover:from-amber-400 hover:to-amber-600 text-black font-bold px-8 py-4 rounded-full text-lg transition-all duration-300 shadow-[0_0_20px_rgba(245,158,11,0.4)] transform hover:scale-105 active:scale-95 uppercase tracking-wide" data-id="element-29">
            Obtener Libro + 3 Bonos Gratis
          </a>
        </div>
      </div>
    </section>;
}